import { Component, OnInit, Input, Output } from '@angular/core';
import { EventEmitter, OnChanges } from '@angular/core';
import { PreferencesService } from '../../../core/services/preferences.service';
import { Observable } from 'rxjs/Observable';

/**
 * 分页组件
 *
 * totalNum   : 总记录数
 * totalPage  : 总页数
 * currentPage: 当前页
 * pageSize   : 每页记录数
 * change     : 页码改变事件
 */
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.css']
})

export class PaginationComponent implements OnInit, OnChanges {

    @Input('total-num') totalNum = 0;
    @Input('current-page') currentPage = 0;
    @Input('page-size') pageSize = 10;

    @Output('pageChange') change: EventEmitter<any> = new EventEmitter<any>();

    arrOptions: number[] = [5, 10, 20, 50, 100];
    totalPage = 0;
    pageNum = '';

    constructor(
        private preferences: PreferencesService
    ) { }

    // get pageNum() {
    //     return this._pageNum;
    // }

    // set pageNum(value) {
    //     // this._pageNum = value;
    //     if (!value) {
    //         this._pageNum = '1';
    //     }
    //     if ((/^\+?[1-9][0-9]*$/).test(value)) {
    //         const num = parseInt(value, null);
    //         console.log(num);
    //         console.log(this.totalPage);
    //         if (num > this.totalPage) {
    //             this._pageNum = '' + this.totalPage;
    //         } else if (num < 1) {
    //             this._pageNum = '1';
    //         } else {
    //             this._pageNum = '' + num;
    //         }
    //         console.log(this._pageNum);
    //     }
    // }

    ngOnInit() {
        if (this.arrOptions.indexOf(this.pageSize) === -1) {
            this.pageSize = this.arrOptions[0];
            console.warn('无效的pageSize参数');
        }
        this.totalPage = Math.ceil(this.totalNum / this.pageSize);

        // Observable.fromEvent(document.querySelector('.goPage'), 'keyup')
        //     .subscribe((x: string) => this.pageNum = x);
    }

    ngOnChanges() {
        this.totalPage = Math.ceil(this.totalNum / this.pageSize);
    }

    pageChange() {
        this.currentPage = 1;
        this.totalPage = Math.ceil(this.totalNum / this.pageSize);
        this.change.emit(this.genEvent());
        this.preferences.set('pageSize', this.pageSize, false);
    }

    genEvent() {
        return {
            currentPage: this.currentPage,
            pageSize: this.pageSize
        };
    }

    goPage(num) {

        if (typeof num !== 'number' && typeof num !== 'string') {
            return;
        } else if (typeof num === 'string') {
            if (!/^[1-9]+[0-9]*$/.test(num)) {
                return;
            } else {
                num = parseInt(num, 10);
            }
        }

        if (num < 1 || num > this.totalPage) {
            return;
        }

        if (num !== this.currentPage) {
            this.currentPage = num;
            this.change.emit(this.genEvent());
        }

    }


    get recordTotal() {
        return { totalNum: this.totalNum };
    }
    get pageTotal() {
        return { totalPage: this.currentPage + '/' + this.totalPage };
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/shared/components/pagination/pagination.component.ts